import React, { useState } from 'react';
import './ModulesPage.css';

const DemoPage = ({ onBack }) => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  const videoSrc = '/demo/demo-video.mp4'; 
  const reportPdf = '/demo/report.pdf'; 
  const reportThumbnail = '/demo/report-preview.png'; 
  const videoThumbnail = '/demo/demo-poster.jpg'; 

  return (
    <div className="modules-container">
      {/* НИ ОДНОГО ЛИШНЕГО СТИЛЯ ДЛЯ ШИРИНЫ. ТОЛЬКО КЛАСС ИЗ ТВОЕГО CSS */}
      <div className="modules-card">
        
                {/* ШАПКА КАК В MODULESPAGE */}
        <header className="modules-header">
          <button className="back-btn" onClick={onBack} style={{ marginRight: '40px' }}>
            ← Назад
          </button>
          
          <h1 style={{ margin: 0, fontSize: '24px', color: '#1A1A2E', fontWeight: 'bold', textAlign: 'center', flex: 1 }}>
            Как пользоваться приложением (полезные функции)
          </h1>
          
          {/* Пустышка справа, чтобы заголовок был ровно по центру */}
          <div style={{ width: '100px', flexShrink: 0, marginLeft: '40px' }}></div>
        </header>

        {/* КОНТЕНТ */}
        <div style={{ display: 'flex', gap: '30px', marginTop: '20px', flexWrap: 'nowrap', alignItems: 'stretch' }}>
          
          {/* ЛЕВАЯ ЧАСТЬ: ВИДЕО (занимает всё место) */}
          <div style={{ 
            flex: 1, 
            minWidth: 0,
            display: 'flex', 
            flexDirection: 'column',
            background: '#F8F6FF', 
            padding: '24px', 
            borderRadius: '16px', 
            border: '2px solid #E5E0F5',
            boxSizing: 'border-box'
          }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '22px', color: '#1A1A2E', textAlign: 'center' }}>Видеоинструкция</h3>
            
            {/* Превью видео (альбомная ориентация) */}
            <div 
              style={{ 
                position: 'relative', 
                width: '100%', 
                paddingTop: '56.25%', /* ЖЕСТКИЕ ПРОПОРЦИИ 16:9 */
                height: 0, 
                borderRadius: '12px', 
                overflow: 'hidden', 
                border: '2px solid #E5E0F5',
                cursor: 'pointer',
                background: '#000' 
              }}
              onClick={() => setIsVideoOpen(true)}
            >
              <img 
                src={videoThumbnail} 
                alt="Превью видео" 
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }} 
              />
              {/* Кнопка воспроизведения поверх картинки */}
              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.3)' }}>
                <div style={{ width: '70px', height: '70px', background: '#fff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '30px', color: '#7B4EF8' }}>▶</div>
              </div>
            </div>

            <button
              onClick={() => setIsVideoOpen(true)}
              style={{ marginTop: '20px', padding: '14px 28px', borderRadius: '50px', background: 'linear-gradient(130.29deg, #9061F9 0%, #6D28D9 100%)', color: '#fff', border: 'none', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }}
            >
              ▶ Смотреть видео
            </button>
          </div>

          {/* ПРАВАЯ ЧАСТЬ: ОТЧЕТ (фиксированная ширина 350px) */}
          <div style={{ 
            flex: '0 0 350px', 
            display: 'flex', 
            flexDirection: 'column', 
            background: '#F8F6FF', 
            padding: '24px', 
            borderRadius: '16px', 
            border: '2px solid #E5E0F5',
            boxSizing: 'border-box'
          }}>
            <h3 style={{ margin: '0 0 20px', fontSize: '22px', color: '#1A1A2E', textAlign: 'center' }}>Пример отчёта</h3>
            
            <img
              src={reportThumbnail}
              alt="Превью отчёта"
              style={{ width: '100%', height: '300px', objectFit: 'cover', objectPosition: 'top', borderRadius: '12px', border: '1px solid #E5E0F5', marginBottom: '20px', cursor: 'pointer' }}
              onClick={() => setIsReportOpen(true)}
            />
            
            <button
              onClick={() => setIsReportOpen(true)}
              style={{ marginTop: 'auto', padding: '14px 28px', borderRadius: '50px', background: 'linear-gradient(130.29deg, #9061F9 0%, #6D28D9 100%)', color: '#fff', border: 'none', fontWeight: 'bold', cursor: 'pointer', fontSize: '16px' }}
            >
              Полная версия
            </button>
          </div>
        </div>
      </div>

      {/* ВСПЛЫВАЮЩЕЕ ОКНО С ВИДЕО */}
      {isVideoOpen && (
        <div
          style={{ 
            position: 'fixed', 
            top: 0, left: 0, right: 0, bottom: 0, 
            backgroundColor: 'rgba(0,0,0,0.9)', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            zIndex: 9999, 
            padding: '40px 20px' 
          }}
          onClick={() => setIsVideoOpen(false)}
        >
          <div
            style={{ 
              background: '#000', 
              borderRadius: '16px', 
              maxWidth: '1000px', 
              width: '100%', 
              aspectRatio: '16 / 9', 
              position: 'relative', 
              boxShadow: '0 10px 30px rgba(0,0,0,0.5)' 
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setIsVideoOpen(false)}
              style={{ 
                position: 'absolute', 
                top: '-40px', 
                right: '0', 
                background: '#fff', 
                border: 'none', 
                borderRadius: '50%', 
                width: '36px', 
                height: '36px', 
                fontSize: '18px', 
                cursor: 'pointer', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                color: '#333', 
                fontWeight: 'bold' 
              }}
            >
              ✕
            </button>
            <video 
              controls 
              autoPlay 
              style={{ width: '100%', height: '100%', borderRadius: '16px' }}
            >
              <source src={videoSrc} type="video/mp4" />
              Ваш браузер не поддерживает видео.
            </video>
          </div>
        </div>
      )}

      {/* ВСПЛЫВАЮЩЕЕ ОКНО С PDF ОТЧЕТОМ */}
      {isReportOpen && (
        <div
          style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999, padding: '40px 20px' }}
          onClick={() => setIsReportOpen(false)}
        >
          <div
            style={{ background: '#fff', borderRadius: '16px', maxWidth: '1000px', width: '100%', height: '90vh', overflow: 'hidden', position: 'relative', padding: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)', display: 'flex', flexDirection: 'column' }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h2 style={{ margin: 0, color: '#333', fontSize: '22px' }}>Пример подробного отчёта</h2>
              <button onClick={() => setIsReportOpen(false)} style={{ background: '#f0f0f0', border: 'none', borderRadius: '50%', width: '36px', height: '36px', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#333', fontWeight: 'bold', flexShrink: 0 }}>✕</button>
            </div>
            <iframe src={reportPdf} title="Пример отчета EZSpeech" style={{ width: '100%', flex: 1, border: '1px solid #eee', borderRadius: '8px' }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoPage;